function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import nullthrows from "../lib/nullthrows";

var Rect = /*#__PURE__*/function () {
  function Rect(rect, domain) {
    _classCallCheck(this, Rect);

    this.bottom = void 0;
    this.domain = void 0;
    this.height = void 0;
    this.left = void 0;
    this.right = void 0;
    this.top = void 0;
    this.width = void 0;
    this.top = rect.top;
    this.right = rect.right;
    this.bottom = rect.bottom;
    this.left = rect.left;
    this.width = rect.width;
    this.height = rect.height;
    this.domain = domain;
  }

  _createClass(Rect, null, [{
    key: "fromClientRect",
    value: function fromClientRect(rect, domain) {
      var top = rect.top,
          right = rect.right,
          bottom = rect.bottom,
          left = rect.left,
          width = rect.width,
          height = rect.height;

      if (domain === 'viewport') {
        return new Rect({
          top: top,
          right: right,
          bottom: bottom,
          left: left,
          width: width,
          height: height
        }, 'viewport');
      }

      var documentElement = nullthrows(document.documentElement);
      var body = nullthrows(document.body);
      var leftAdjust = window.pageXOffset || documentElement.scrollLeft || body.scrollLeft;
      var topAdjust = window.pageYOffset || documentElement.scrollTop || body.scrollTop;
      return new Rect({
        top: top + topAdjust,
        left: left + leftAdjust,
        bottom: bottom,
        right: right,
        width: width,
        height: height
      }, 'document');
    }
  }]);

  return Rect;
}();

export default Rect;